module.exports = __webpack_public_path__ + "img/604-42dfb3.png";